
import TitleBox from '@/components/CSS/TitleBox'

export default {
    components: {
        TitleBox
    },
    data() {
        return {
            messageDetail: {}
        }
    },
    mounted() {
        const detail = sessionStorage.getItem('message-detail')
        this.messageDetail = JSON.parse(detail)
    },
}
